<template>
  <div>
    <h2>{{ $t("tvshows.library") }}</h2>
    <v-layout row wrap>
      <v-flex xs6 sm4 md3 lg2 v-for="tvshow in tvshows" :key="tvshow.id">
        <TVShowsCard
          :id="tvshow.data.tmdb_id"
          :title="tvshow.data.tvshow_title"
          :year="(new Date(tvshow.data.tvshow_first_air_date)).getFullYear()"
          :poster="tvshow.data.tvshow_poster_path"
        ></TVShowsCard>
      </v-flex>
    </v-layout>
    <v-card v-intersect="infiniteScrolling"></v-card>
  </div>
</template>

<script>
import TVShowsCard from "./TVShowsCard";
import { storage } from "../../schmucklicloud";
export default {
  data() {
    return {
      tvshows: [],

      last_tvshows_length: 0,
      db_offset: 0
    };
  },
  mounted() {
    this.loadLibraryTVShows(0, 15);
  },
  methods: {
    infiniteScrolling() {
      if (this.last_tvshows_length === this.tvshows.length) {
        return;
      } else {
        this.last_tvshows_length = this.tvshows.length;
        setTimeout(
          function() {
            this.loadLibraryTVShows(this.db_offset, 15);
          }.bind(this),
          1000
        );
      }
    },
    async loadLibraryTVShows(start, limit) {
      let dateFilter = this.$route.query.date;
      let targetYear = null;
      let targetMonth = null;
      if (dateFilter) {
          let parts = dateFilter.split('-');
          targetYear = parseInt(parts[0]);
          targetMonth = parseInt(parts[1]);
      }
      let limitToUse = dateFilter ? 100 : limit;
      
      let response;
      if (dateFilter) {
          response = await storage.get(
              "tvshows",
              [ { column: "watched_year", operator: "==", value: targetYear } ],
              [ { column: "watched_month", order: "desc" } ],
              start,
              limitToUse
          );
      } else {
          response = await storage.getAll(
            "tvshows",
            [
              { column: "watched_year", order: "desc" },
              { column: "watched_month", order: "desc" }
            ],
            start,
            limitToUse
          );
      }

      if (response.isOK && response.data !== undefined) {
        this.db_offset = start + response.data.length;
        if (dateFilter) {
            let filtered = response.data.filter(t => parseInt(t.data.watched_month) === targetMonth);
            this.tvshows = this.tvshows.concat(filtered);
        } else {
            this.tvshows = this.tvshows.concat(response.data);
        }
      }
    }
  },
  components: {
    TVShowsCard
  }
};
</script>

<style>
</style>